import { Component, OnInit } from '@angular/core';
import { UtilitiesService } from './shared/services/utilities/utilities.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private utilities: UtilitiesService,
  ) { }

  ngOnInit(): void {
    this.utilities.loadExternalScripts();
    this.utilities.loadExternalStyleSheets();
  }
}
